import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {TicketBuyResultVo} from '../../common/shared/api/nicolas/vo/TicketBuyResultVo.interface';

/**
 * 이용권 구매
 *
 * Origin: pageNicolasApi.postTicketBuy
 * API: POST /api/v1/ticket/buy
 */
export async function postTicketBuy(
  {
    seriesId,
    ticketList,
    type,
  }: {
    seriesId: number;
    ticketList: {[_: string]: number};
    /**
     * 1 : 소장
     * 2 : 대여
     */
    type: 1 | 2;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: TicketBuyResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/buy',
    {
      method: 'POST',
      data: {
        series_id: seriesId,
        // ⚠️ 특수 로직: property가 double quote로 감싸있으면 400 에러 발생
        // double quote를 제거해야 함
        ticket_list: JSON.stringify(ticketList).replace(/"([^"]+)":/g, '$1:'),
        type,
      },
    },
    options
  );
  return response.data;
}
